import Text from "components/common/Text/Text";
import styled from "styled-components";
import theme from "themes/simple-theme";

export const FormLabelWrapper = styled(Text)`
  font-size: ${theme.fontSize.s};
  margin-bottom: 1vh;
`;

export const FormInputWrapper = styled("input")`
  text-align: left;
  box-sizing: border-box;
  border: none;
  width: 100%;
  padding: ${theme.fontSize.m};
  margin-bottom: 2.2vh;
  background: ${theme.color.gray.light};
  font-size: ${theme.fontSize.l};
  font-family: ${theme.fontFamily.light};
  color: ${theme.color.primary};
  border-radius: ${theme.global.radius};
  transition: ${theme.global.transition};
`;

export const FormDatePickerWrapper = styled.div`
  position: relative;
`;

FormInputWrapper.defaultProps = {
  readOnly: true
};



// WEBPACK FOOTER //
// ./src/components/common/Form/Form.style.tsx